import { apiRequestRaw } from "../http";
import type {
	SaveCertificatesRequest,
	SaveCertificatesResponse,
} from "../../types/save-certificates.type";
import { normalizeAccountCardId } from "../../utils/normalize-account-card-id";

/** POST /api/ui/account/certificates — desired cert set for one sub-account. */
export async function saveAccountCertificates(
	body: SaveCertificatesRequest,
): Promise<SaveCertificatesResponse> {
	const payload: SaveCertificatesRequest = {
		account_id: normalizeAccountCardId(body.account_id),
	};
	if (body.gambling !== undefined) {
		payload.gambling = body.gambling;
	}
	if (body.social_casino !== undefined) {
		payload.social_casino = body.social_casino;
	}

	return apiRequestRaw<SaveCertificatesResponse>({
		path: "/api/ui/account/certificates",
		method: "POST",
		json: payload,
	});
}
